import { render, staticRenderFns } from "./OfertaMateriale.vue?vue&type=template&id=4cc062e0&scoped=true"
import script from "./OfertaMateriale.vue?vue&type=script&lang=js"
export * from "./OfertaMateriale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc062e0",
  null
  
)

export default component.exports